export const AUTOSAVE_DRAFT_VERSION = '0.0.1';
